import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { PostProductPaymentProcessBody, PostProductPaymentProcessResponse } from '@/payment/types'

/**
 * 토스/네이버 successUrl 중계 — 결제 데이터 저장.
 *
 * `/sealed-vinyl/process` 라우트에서 진입 즉시 호출.
 * 응답으로 받은 `key`를 `/sealed-vinyl/result?key=UUID`로 전달하면
 * `/result` 페이지가 GET /product-payments/process/{key}로 데이터를 다시 가져와 콜백을 호출한다.
 */
export const apiPostProductPaymentProcess = async (
  body: PostProductPaymentProcessBody
): Promise<PostProductPaymentProcessResponse> => {
  return api.post(`${API_PREFIX.PAYMENT}/product-payments/process`, body)
}
